import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { SideNav, Header, MobileNav } from '../template';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  // Lock body scroll when sidebar is open on mobile
  useEffect(() => {
    if (sidebarOpen && window.innerWidth < 1024) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [sidebarOpen]);

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Desktop Sidebar - always visible on lg+ */}
      <div className="hidden lg:block">
        <SideNav collapsed={sidebarCollapsed} />
      </div>

      {/* Mobile Navigation - visible on smaller screens when open */}
      <MobileNav isOpen={sidebarOpen} onClose={closeSidebar} />

      {/* Header */}
      <Header
        onSidebarToggle={toggleSidebar}
        sidebarCollapsed={sidebarCollapsed}
      />

      {/* Main Content */}
      <main
        className={classNames('ecme-main-content', {
          'sidebar-collapsed': sidebarCollapsed,
        })}
      >
        {children}
      </main>
    </div>
  );
};

export default Layout;
